import gql from 'graphql-tag';

export default gql`
    mutation VosUploadImage($input: VosUploadImageInput) {
        vosUploadImage(input: $input) {
            errors
        }
    }
`;
